import React, { useState } from 'react';

import { Tab } from '@headlessui/react';

import type { Stock } from '../../output/models';
import type { GetStockData200ResponseData as Data } from '../../output/models';

import { CashFlowTab, DisclosureTab, MemoTab, MonthlyTab, StockPriceTab, SummaryTab } from './Tabs';

import { tabClassName } from '../../utils';

interface Props {
  code: string;
  stock: Stock | undefined;
  term: string | null;
  quarter: number | undefined;
  data: Data;
}

export const StockTabs: React.FC<Props> = ({ code, stock, term, quarter, data }) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const monthly = data.monthly;

  return (
    <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
      <Tab.List className="border-b border-gray">
        <Tab className={({ selected }) => tabClassName(selected)}>決算短信</Tab>
        <Tab className={({ selected }) => tabClassName(selected)}>キャッシュフロー</Tab>
        {monthly && <Tab className={({ selected }) => tabClassName(selected)}>月次</Tab>}
        <Tab className={({ selected }) => tabClassName(selected)}>予想PER</Tab>
        <Tab className={({ selected }) => tabClassName(selected)}>PBR</Tab>
        <Tab className={({ selected }) => tabClassName(selected)}>営業利益倍率</Tab>
        <Tab className={({ selected }) => tabClassName(selected)}>FCF倍率</Tab>
        <Tab className={({ selected }) => tabClassName(selected)}>開示（2年分）</Tab>
        <Tab className={({ selected }) => tabClassName(selected)}>個人メモ</Tab>
      </Tab.List>
      <Tab.Panels className="mt-5">
        <Tab.Panel unmount={false}>
          <SummaryTab
            code={code}
            term={term}
            quarter={quarter}
            financialsFull={data.financials.full}
            financialsQuarter={data.financials.quarter}
            progressRatios={data.progress_ratios}
          />
        </Tab.Panel>
        <Tab.Panel unmount={false}>
          <CashFlowTab
            code={code}
            term={term}
            quarter={quarter}
            cashFlowsFull={data.cash_flows.full}
            cashFlowsQuarter={data.cash_flows.quarter}
          />
        </Tab.Panel>
        {monthly && (
          <Tab.Panel unmount={false}>
            {({ selected }) => <MonthlyTab code={code} selected={selected} />}
          </Tab.Panel>
        )}
        <Tab.Panel className="min-h-[924px]" unmount={false}>
          {({ selected }) => <StockPriceTab code={code} indice={'per'} selected={selected} />}
        </Tab.Panel>
        <Tab.Panel className="min-h-[924px]" unmount={false}>
          {({ selected }) => <StockPriceTab code={code} indice={'pbr'} selected={selected} />}
        </Tab.Panel>
        <Tab.Panel className="min-h-[924px]" unmount={false}>
          {({ selected }) => (
            <StockPriceTab code={code} indice={'operating-income-ratio'} selected={selected} />
          )}
        </Tab.Panel>
        <Tab.Panel className="min-h-[924px]" unmount={false}>
          {({ selected }) => <StockPriceTab code={code} indice={'fcf-ratio'} selected={selected} />}
        </Tab.Panel>
        <Tab.Panel unmount={false}>
          {({ selected }) => <DisclosureTab code={code} selected={selected} />}
        </Tab.Panel>
        <Tab.Panel unmount={false}>
          {({ selected }) => <MemoTab code={code} selected={selected} stockId={stock!.id} />}
        </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>
  );
};
